<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-date-picker v-model="today" type="month" placeholder="选择日期" @change="search"
          :clearable="false" :editable="false" style="margin-left: 10px;"></el-date-picker>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="toexcel">表格导出</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="100%" style="width: 100%">
          <el-table-column align="center" label="姓名" min-width="100" prop="renyuan"></el-table-column>
          <el-table-column align="center" label="工种" min-width="100" prop="gongzhong"></el-table-column>
          <el-table-column align="center" label="应出勤天数" min-width="100" prop="yingchuqin"></el-table-column>
          <el-table-column align="center" label="实际出勤天数" min-width="100" prop="shijichuqin"></el-table-column>
          <el-table-column align="center" label="总工时" min-width="100" prop="zonggongshi"></el-table-column>
          <el-table-column align="center" label="计件工资" min-width="100" prop="jijiangongzi"></el-table-column>
          <el-table-column align="center" label="临时用工费用" min-width="100" prop="linshiyonggong"></el-table-column>
          <el-table-column align="center" label="借调工资" min-width="100" prop="jiediaogongzi"></el-table-column>
          <el-table-column align="center" label="保底工资" min-width="100" prop="baodigongzi"></el-table-column>
          <el-table-column align="center" label="正常工资" min-width="100" prop="zhengchanggongzi"></el-table-column>
          <el-table-column align="center" label="补上月工资" min-width="100" prop="bushangyue"></el-table-column>
          <el-table-column align="center" label="补助" min-width="100" prop="buzhu"></el-table-column>
          <el-table-column align="center" label="餐补" min-width="100" prop="canbu"></el-table-column>
          <el-table-column align="center" label="加班费" min-width="100" prop="jiabanfei"></el-table-column>
          <el-table-column align="center" label="介绍费" min-width="100" prop="jieshaofei"></el-table-column>
          <el-table-column align="center" label="其他补助" min-width="100" prop="qitabuzhu"></el-table-column>
          <el-table-column align="center" label="公积金扣款" min-width="100" prop="gongjijinkoukuan"></el-table-column>
          <el-table-column align="center" label="其他扣款" min-width="100" prop="qitakoukuan"></el-table-column>
          <el-table-column align="center" label="保险补贴" min-width="100" prop="baoxianbutie"></el-table-column>
          <el-table-column align="center" label="应付工资" min-width="100" prop="yingfugongzi"></el-table-column>
          <el-table-column align="center" label="扣五险一金金额" min-width="100" prop="wuxianyijin"></el-table-column>
          <el-table-column align="center" label="8%(养老)" min-width="100" prop="yanglao"></el-table-column>
          <el-table-column align="center" label="0.5%(失业)" min-width="100" prop="shiye"></el-table-column>
          <el-table-column align="center" label="2%(医疗)" min-width="100" prop="yiliao"></el-table-column>
          <el-table-column align="center" label="重大疾病" min-width="100" prop="zhongdajibing"></el-table-column>
          <el-table-column align="center" label="公积金8%" min-width="100" prop="gongjijin"></el-table-column>
          <el-table-column align="center" label="五险一金其他" min-width="100" prop="wuxianqita"></el-table-column>
          <el-table-column align="center" label="个人所得税" min-width="100" prop="suodeshui"></el-table-column>
          <el-table-column align="center" label="实发工资" min-width="100" prop="shifagongzi"></el-table-column>
          <el-table-column align="center" label="保险差额" min-width="100" prop="baoxianchae"></el-table-column>
          <el-table-column align="center" label="领取人签字" min-width="100" prop="lingquren"></el-table-column>
        </el-table>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keywordType: 1,
      sf: '',
      today: '',
    }
  },

  created() {
    this.today = new Date();
    this.sf = localStorage.sf
    this.getList()
  },

  methods: {
    toexcel() {
      this.listLoading = true
      let data = {
        year: this.today.getFullYear(),
        month: (this.today.getMonth()+1),
      }
      axios.post(this.$host+'/index.php/admin/Gongziexcel/gzhuizongbExcel', data,
        {
          responseType: "blob", //二进制流
        }).then((res) => {
        const fileName = '工资汇总报表';
        this.downloadFile(res.data, fileName);
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
    
    // 下载文件
    downloadFile(blobData, fileName) {
      // 创建Blob对象
      const blob = new Blob([blobData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      
      // 创建下载链接
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName; // 设置文件名
      
      // 触发下载
      document.body.appendChild(a);
      a.click();
      
      // 清理资源
      document.body.removeChild(a);
      URL.revokeObjectURL(url); // 释放URL对象
    },
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.search()
    },
    
    getList() {
      this.listLoading = true
      let data = {
        year: this.today.getFullYear(),
        month: (this.today.getMonth()+1),
      }
      this.$request.post('/index.php/admin/Gongzibiao/gzhuizongb', data).then((res) => {
        this.list = res.data.data
        this.total = res.data.count
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
